import moment from 'moment'
import momentTz from 'moment-timezone'

export default angular
  .module('adminPanel.filters', [])
  .filter('timeAgo', function() {
    return function(timeGMT) {
      if (timeGMT && timeGMT.length > 0) {
        return moment(timeGMT).fromNow()
      }
      return timeGMT
    }
  })
  .filter('importDateFormat', function() {
    return function(time) {
      if (time) {
        return moment(time).format('YYYY-MM-DD')
      }
    }
  })
  .filter('readableTimestamp', function() {
    return function(time) {
      if (time) {
        return moment(time)
          .tz('America/Los_Angeles')
          .format('MMMM Do YYYY, h:mm:ss a')
      }
    }
  })
  .filter('dateTimestampSeconds', function() {
    return function(time) {
      if (time) {
        return moment(time)
          .tz('America/Los_Angeles')
          .format('M/D/YYYY, h:mm:ss a')
      }
    }
  })
  .filter('dateTimestamp', function() {
    return function(time) {
      if (time) {
        return moment(time)
          .tz('America/Los_Angeles')
          .format('M/D/YYYY, h:mm a z')
      }
    }
  })
  .filter('jsonPrettyPrint', function() {
    function syntaxHighlight(json) {
      json = json
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
      return json.replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
        function(match) {
          var cls = 'number'
          if (/^"/.test(match)) {
            if (/:$/.test(match)) {
              cls = 'key'
            } else {
              cls = 'string'
            }
          } else if (/true|false/.test(match)) {
            cls = 'boolean'
          } else if (/null/.test(match)) {
            cls = 'null'
          }
          return '<span class="' + cls + '">' + match + '</span>'
        }
      )
    }
    return function(obj) {
      var str = JSON.stringify(obj)
      return syntaxHighlight(str)
    }
  })
